import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Drawer,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";

import { Link } from "react-router-dom";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialTypeService } from "_services";

function History({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [historyItems, setHistoryItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    materialTypeService
      .getHistory(id)
      .then((x) => {
        setHistoryItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Code",
      dataIndex: "item.code",
      key: "Code",
      width: "10%",
      render: (text, record) => {
        if (record) {
          return `${record?.item?.code}`;
        }
      },
    });

    columns.push({
      title: "Item Name",
      dataIndex: "item.name",
      key: "itemname",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.item?.name}`;
        }
      },
    });
    columns.push({
      title: "Username",
      dataIndex: "employee.username",
      key: "Username",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.employee?.username}`;
        }
      },
    });

    columns.push({
      title: "Event",
      dataIndex: "event",
      key: "evente",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.event}`;
        }
      },
    });

    columns.push({
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      width: "30%",
      render: (text, record) => {
        if (record) {
          return `${record?.notes}`;
        }
      },
    });
    columns.push({
      title: "Event Date",
      dataIndex: "eventDate",
      key: "eventDate",
      //width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.eventDate}`;
        }
      },
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/bom/boms/">BOM</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> History </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      // extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={isLoading}>
          <TabMenu menu="history" id={id} />

          {historyItems && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={historyItems}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default History;
